import { Outlet } from 'react-router-dom';

/**
 * Shell for nested super-admin routes. Sidebar lives in DashboardLayout.
 */
export default function SuperAdminLayout() {
  return <Outlet />;
}
